// OfflineListNotice (gh-471, issue point 4) — the calm offline state for an ONLINE-ONLY list.
//
// The clients list is not cached to IDB (that is the deferred Option B), so offline it cannot load.
// Instead of hanging on an infinite "Loading clients…" spinner (the reported defect) or flashing the
// red "Couldn't load clients" error (which reads as a failure, not an expected offline state), the
// clients surfaces render THIS neutral panel: honest ("you're offline"), non-alarming (muted, not
// error-red — clinical UX), and actionable ("reconnect"). Tokens only; no pure-white background.
//
// Rendered by `ClientsListScreen` + the Workspace `ClientListSection` when the list query failed
// with a transport error (`isOfflineError(query.error)`).

export function OfflineListNotice({
  message = "You're offline. Reconnect to load this list.",
}: {
  message?: string;
}) {
  return (
    <div
      role="status"
      className="flex flex-col items-center gap-2 rounded-2xl border border-[color:var(--border-primary)] bg-[color:var(--bg-secondary)] px-6 py-10 text-center"
    >
      <p className="text-md text-[color:var(--text-secondary)]">{message}</p>
      <p className="text-sm text-[color:var(--text-tertiary)]">
        Any work already open on this device stays saved and continues offline.
      </p>
    </div>
  );
}

export default OfflineListNotice;
